import {ImageVariants} from '~/src/types/data/common';
import {ContentType} from '~/src/utilities/constants/types';

interface TeaserObject {
    title: string;
    titleHeader?: string;
    description: string;
    images?: ImageVariants;
}

interface MetaTeaser {
    web: TeaserObject;
    facebook: TeaserObject;
    twitter: TeaserObject;
}

const buildTeaserContent = (defaultData: any, contentData: any, teaserData: any = null): TeaserObject => {
    const hasTeaser =
        (teaserData?.title && teaserData?.title !== defaultData.title) ||
        (teaserData?.titleHeader && teaserData?.titleHeader !== defaultData.titleHeader) ||
        (teaserData?.lead && teaserData?.lead !== defaultData.lead);

    return {
        titleHeader: teaserData !== null ? undefined : contentData?.titleHeader || defaultData.titleHeader,
        title: hasTeaser ? teaserData?.title : contentData.title || defaultData?.title,
        description: hasTeaser ? teaserData?.lead : (typeof contentData?.lead === 'object' ? contentData.lead.text : contentData?.lead) || defaultData.lead,
        images: teaserData?.image?.variants || defaultData.image?.variants
    };
};

export const getMetaTeaser = (props: any): MetaTeaser => {
    const feedType = props.type !== ContentType.LIFESTYLE ? props.type : ContentType.ARTICLE;

    const teaserData = props.content.meta.teaser;
    const defaultData = teaserData?.default;
    const facebookData = teaserData?.facebook;
    const twitterData = teaserData?.twitter;
    const contentData = props.content[feedType];

    return {
        web: buildTeaserContent(defaultData, contentData),
        facebook: buildTeaserContent(defaultData, contentData, facebookData),
        twitter: buildTeaserContent(defaultData, contentData, twitterData)
    };
};
